import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TopbarControlsService {
	private _template$ = new BehaviorSubject<TemplateRef<any> | null>(null);
	readonly template$ = this._template$.asObservable();

	register(template: TemplateRef<any>): void {
		this._template$.next(template);
	}

	clear(): void {
		this._template$.next(null);
	}
}
